// Throttles a function based on an identifier.  Returns boolean whether the function was run or not.

let timerMap: { [key: string]: any; } = {};

export const throttle = (fn: () => void, identifier: string, throttleMs: number) => {
    if (!timerMap[identifier]) {
        fn();
        timerMap[identifier] = setTimeout(() => delete timerMap[identifier], throttleMs);
        return true;
    }
    return false;
}